import axios from 'axios';

export default {
    list() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/pro/list');
    },

    listDates(proId, userId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/pro/' + proId + '/dates/' + userId);
    },

    getDetail(proId, userId, date) {
        let params = date ? '?date=' + date : '';
        return axios.get(process.env.VUE_APP_API_URI + '/api/pro/' + proId + '/detail/' + userId + params);
    },

    patchUserPro(proId, userId, data) {
        return axios.patch(process.env.VUE_APP_API_URI + '/api/pro/' + proId + '/detail/' + userId, data);
    },

    downloadUserPro(proId, userId) {
        return axios({
            url: process.env.VUE_APP_API_URI + '/api/pro/' + proId + '/download/' + userId,
            method: 'GET',
            responseType: 'blob'
        })
    },
}
